import { useParams } from "react-router-dom";

interface ReturnValues {
  customer_id: number | undefined;
  sub_id: number | undefined;
  supplier_id: number | undefined;
  mrf_id: number | undefined;
  rfq_id: number | undefined;
  uuid: string | undefined;
  rfqTrnSupplyId: number | undefined;
  company_id: number | undefined;
  user_id: number | undefined;
  siteID: number | undefined;
  junctionID: number | undefined;
  item_id: number | undefined;
  group_id: number | undefined;
  momID: number | undefined;
  projectID: number | undefined;
  itemDetailId: number | undefined
}
const useUrlParams = (): ReturnValues => {
  const {
    customerId,
    subId,
    supplier_id,
    mrf_id,
    rfqId,
    uuid,
    rfqTrnSupplyId,
    companyId,
    userId,
    siteId,
    junctionID,
    itemId,
    groupId,
    momId,
    projectId,
    itemDetailId
  } = useParams();

  return {
    customer_id: customerId ? Number(customerId) : undefined,
    sub_id: subId ? Number(subId) : undefined,
    supplier_id: supplier_id ? Number(supplier_id) : undefined,
    mrf_id: mrf_id ? Number(mrf_id) : undefined,
    rfq_id: rfqId ? Number(rfqId) : undefined,
    uuid: uuid,
    rfqTrnSupplyId: rfqTrnSupplyId ? Number(rfqTrnSupplyId) : undefined,
    company_id: companyId ? Number(companyId) : undefined,
    user_id: userId ? Number(userId) : undefined,
    siteID: siteId ? Number(siteId) : undefined,
    junctionID: junctionID ? Number(junctionID) : undefined,
    item_id: itemId ? Number(itemId) : undefined,
    group_id: groupId ? Number(groupId) : undefined,
    momID: momId ? Number(momId) : undefined,
    projectID: projectId ? Number(projectId) : undefined,
    itemDetailId: itemDetailId ? Number(itemDetailId) : undefined
  };
};

export default useUrlParams;
